import { render, staticRenderFns } from "./linked-tickets.vue?vue&type=template&id=0d45879c&scoped=true"
import script from "./linked-tickets.js?vue&type=script&lang=js&external"
export * from "./linked-tickets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45879c",
  null
  
)

export default component.exports